const padMinutes = (value) => String(value).padStart(2, '0');

export function formatAttendanceHours(seconds) {
  if (seconds === null || seconds === undefined || seconds === '') return '—';
  const value = Number(seconds);
  if (!Number.isFinite(value) || value < 0) return '—';
  const totalMinutes = Math.floor((value + 30) / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${padMinutes(minutes)}m`;
}
